import {getQuestionById, getResultById} from '../selectors';
import {getQuestionPointTotal, getQuestionSelectedValue} from './questions';
const getInitialState = () => {
	return [];
}
const valueComparisonIsValid = (value, operator, compareToValue) => {
	var passes = false;
	// console.log( 'valueComparisonIsValid', value, operator, compareToValue );
	switch( operator ){
		case '<':
			return value < compareToValue;
		case '<=':
			return value <= compareToValue;
		case '>=':
			return value >= compareToValue;
		case '>':
			return value > compareToValue;
		case '!==':
			return value !== compareToValue;
		case '===':
			return value === compareToValue;
		case 'CONTAINS':
			if ( Array.isArray(value) ){
				return value.indexOf(compareToValue) !== -1;
			} else {
				return (''+value).indexOf(compareToValue) !== -1;
			}
		case 'DOES_NOT_CONTAIN':
			if ( Array.isArray(value) ){
				return value.indexOf(compareToValue) === -1;
			} else {
				return (''+value).indexOf(compareToValue) === -1;
			}
		default:
			return false;
	}
}
export function getResultsLogicAnswer(fullState) {
	var matchingLogicGroup = fullState.resultsLogic.find( logicGroup => {
		if ( !logicGroup['result-to-show'] ){
			return false;
		}
		// not a valid result
		if ( !getResultById(fullState, logicGroup['result-to-show']) ){
			console.warn( 'Service Recommender: Invalid result id %s, skipping it', logicGroup['result-to-show'] );
			return false;
		}
		if ( logicGroup['has-total-condition'] ){
			var condition = logicGroup['total-condition'];
			console.log(fullState.totalPoints, condition.operator, condition.points );
			if ( !valueComparisonIsValid( fullState.totalPoints, condition.operator, condition.points ) ){
				return false;
			}
		}
		if ( logicGroup['has-question-conditions'] ){
			// must pass one group
			var logicGroupHasPassed = logicGroup['question-conditions'].find( qc => {
				// but to pass the group, must pass ALL conditions
				var failedOneQuestionCondition = qc.conditions.find( condition => {
					var passed = false;
					var questionId = condition['question-id'];
					var question = questionId ? getQuestionById( fullState, questionId ) : false ;
					if ( question ){
						if ( condition.property === 'points' ){
							var pointTotal = getQuestionPointTotal( question );
							passed = valueComparisonIsValid( condition.value, condition.operator, pointTotal );
						} else if ( condition.property === 'value' ){
							passed = valueComparisonIsValid( condition.value, condition.operator, getQuestionSelectedValue(question) );
						}
					}
					return !passed;
				});
				if ( !failedOneQuestionCondition ){
					return true;
				} else {
					return false;
				}
			});
			if ( !logicGroupHasPassed ){
				return false;
			}
		}
		return true;
	});
	if ( matchingLogicGroup ){
		return getResultById(fullState, matchingLogicGroup['result-to-show']);
	}
	return false;
}
const validOperators = [
	'<', '>', '<=', '>=', '!==', '===', 'CONTAINS', "DOES_NOT_CONTAIN"
];
export default function resultsLogicReducer(state = getInitialState(), action) {
	var newState;
	switch( action.type ){
		case 'resultsLogic/load':
			// any initial processing can go here
			return [...state].map( r => {
				if ( r['has-total-condition'] && r['total-condition'] ){
					r['total-condition'].points = parseInt(r['total-condition'].points);
					r['total-condition'].operator = validOperators.indexOf( r['total-condition'].operator ) !== -1 ? r['total-condition'].operator : null;
				} else {
					r['has-total-condition'] = false;
					r['total-condition'] = null;
				}
				if ( r['has-question-conditions'] && r['question-conditions'] ){
					r['question-conditions'] = r['question-conditions'].map( qc => {
						qc.conditions = qc.conditions.map( condition => {
							if ( condition.property === 'points' ){
								condition.value = parseInt( condition.value );
							}
							condition.operator = validOperators.indexOf( condition.operator ) !== -1 ? condition.operator : null;

							return condition;
						});
						return qc;
					});
				} else {
					r['has-question-conditions'] = false;
					r['question-conditions'] = null;
				}
				return r;
			});
		default:
			return state;
	}
	return state;
}